<template>
<div>
    <v-dialog
       v-model="dialogReporte"
      persistent
       width="700"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          REPORTE DE ASISTENCIAS
          <v-spacer></v-spacer>
          <v-btn flat icon @click="dialogReporte=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 sm3 md3>
              <v-menu
                v-model="menu_fecha_desde"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_desde"
                    label="Fecha Desde"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_desde"
                  @input="menu_fecha_desde=false"
                  locale="es-mx">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3 md3>
              <v-menu
                v-model="menu_fecha_hasta"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_hasta"
                    label="Fecha Hasta"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_hasta"
                  @input="menu_fecha_hasta=false"
                  locale="es-mx">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3 md3>
            </v-flex>
            <v-flex xs12 sm3 md3 class="mt-1">
              <v-btn color="primary" @click="getReportFromApi()" class="mt-2">
                Generar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>

    <v-card-title>
      <v-btn color="primary" @click="dialogReporte=true">
        Reporte Asistencia
      </v-btn>
      <v-spacer/>
      <v-text-field
        v-model="presearch"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="rowItems"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td  class="text-xs-left px-1">
            {{ props.item.colaborador_id }}
          </td>
          <td  class="text-xs-left px-1">
            {{ props.item.numero_empleado }}
          </td>
          <td   class="text-xs-left px-2">
            {{ props.item.nombre_completo }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.empresa }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.puesto }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.status }}
          </td>
          <td  class="text-xs-left px-4">
            <v-btn outlined color="primary" small
                   :to="{name: 'vacaciones', params: {id: props.item.colaborador_id}}">
              Vacaciones
            </v-btn>
            <v-btn outlined color="primary" small
                   :to="{name: 'incapacidades', params: {id: props.item.colaborador_id}}">
              Incapacidades
            </v-btn>
            <v-btn outlined color="primary" small
                   :to="{name: 'inasistencias', params: {id: props.item.colaborador_id}}">
              Inasistencias
            </v-btn>
            <v-btn outlined color="primary" small
                   :to="{name: 'turnos_dobles', params: {id: props.item.colaborador_id}}">
              Turnos Dobles
            </v-btn>
            <v-btn outlined color="primary" small
                   :to="{name: 'descansos', params: {id: props.item.colaborador_id}}">
              Descansos
            </v-btn>
            <v-btn outlined color="primary" small
                   :to="{name: 'formaciones', params: {id: props.item.colaborador_id}}">
              Formacion
            </v-btn>
            <v-btn outlined color="primary" small
                   :to="{name: 'incidencias', params: {id: props.item.colaborador_id}}">
              Incidencias
            </v-btn>
            <v-btn outlined color="primary" small
                   :to="{name: 'desempenios', params: {id: props.item.colaborador_id}}">
              Desempeño
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    presearch: '',
    searchTimer: null,
    search: '',
    menu_fecha_desde: false,
    fecha_desde: null,
    menu_fecha_hasta: false,
    fecha_hasta: null,
    dialogReporte: false,
    rowItems: [],
    pagination: {},
    totalItems: 0,
    loading: false,
    headers: [
      {
        text: 'ID', value: 'empleado_id', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'NÚMERO EMPLEADO', value: 'numero_empleado', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'NOMBRE', value: 'nombre_completo', sortable: true, class: 'px-2',
      },
      {
        text: 'EMPRESA', value: 'empresa', sortable: true, class: 'px-2',
      },
      {
        text: 'PUESTO', value: 'puesto', sortable: true, class: 'px-2',
      },
      {
        text: 'ESTADO', value: 'estado', sortable: true, class: 'px-2',
      },
      {
        text: 'ACCIONES', value: '', sortable: false, class: 'px-2',
      },
    ],
  }),
  created() {
    // this.getReportFromApi();
  },
  methods: {
    getReportFromApi() {
      const formdata = {
        empresa: 'xsp',
        fecha_desde: this.fecha_desde,
        fecha_hasta: this.fecha_hasta,
      };
      this.$store.dispatch('rh/fetchAttendance', formdata)
        .then((data) => {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'asistencia.xlsx');
          document.body.appendChild(link);
          link.click();
          this.dialogReporte = false;
        });
    },
    fetchColaboradores() {
      this.loading = true;
      const {
        sortBy, descending, page, rowsPerPage,
      } = this.pagination;

      const formdata = {
        page,
        per_page: rowsPerPage,
        search: this.search,
        order_by: sortBy,
        descending,
      };
      this.$store.dispatch('rh/fetchRhCollaborators', formdata)
        .then((data) => {
          this.totalItems = data.total;
          this.rowItems = data.colaboradores;
          this.loading = false;
        });
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
  },
  watch: {
    pagination: {
      handler() {
        this.fetchColaboradores();
      },
      deep: true,
    },
    search() {
      this.fetchColaboradores();
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
  },
};
</script>

<style scoped>

</style>
